import React from 'react';
import { styles } from '../TitleSection.css';

export type TitleProps = {
  title: string | undefined;
};

export const Title = ({ title }: TitleProps) => {
  return (
    <div className={`${styles.container} ${styles.titleContainer}`} id="product-title">
      <h1 className={styles.title}>{title}</h1>
    </div>
  );
};
